import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-description">
          Coming soon! We're building a beautiful contact form for you to reach out to us.
        </p>
      </div>
    </div>
  );
};

export default ContactPage; 